import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Section } from 'src/app/classes/section';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Environment } from '../classes/environment';

@Injectable({
    providedIn: 'root'
})
export class SectionService {

	constructor(
        private _http: HttpClient,
		@Inject('environment') private environment: Environment,
		private matSnackBar: MatSnackBar,
	) {}

	getAll(): Observable<Section[]> {

		return this._http.get<Section[]>( this.environment.backendUrl + 'sparte/all' ).pipe( 
			map( sections => {
				// console.log( 'SECTIONS', sections )
				if( !sections ) sections = [];
				for( const s of sections ) {
					if( !s.sparteBezeichnung ) s.sparteBezeichnung = '';
				}
				return sections;
			}),
			catchError(err => {
				console.log( 'An error occurred while fetching the list of sections', err );
				this.matSnackBar.open( 'Beim Abrufen der Sparte-Liste ist ein Fehler aufgetreten', '', { duration: 5000 } );
				return of([]);
			})
		);
	}

	create( section: Section ): Observable<Section> {

		return this._http.post<{ verarbeitet: boolean, sparte: Section }>( 
			this.environment.backendUrl + 'sparte/new',
			section
		).pipe(
			map( response => {
				if( !response || !response.verarbeitet ) {
					this.matSnackBar.open( 'Erstellung fehlgeschlagen', '', { duration: 5000 } );
					return new Section();
				}
				this.matSnackBar.open( 'Erstellung gespeichert', '', { duration: 5000 } );
				return response.sparte;
			}),
			catchError(err => {
				console.log( 'An error occurred while creating a section', err );
				this.matSnackBar.open( 'Beim Erstellen einer Sparte ist ein Fehler aufgetreten', '', { duration: 5000 } );
				return of(new Section());
			})
		)
	}

	update( section: Section ): Observable<boolean> {

		return this._http.put<Section>( 
			this.environment.backendUrl + 'sparte/update',
			section
		).pipe(
			map( response => {
				if( !response ) {
					this.matSnackBar.open( 'Änderung fehlgeschlagen', '', { duration: 5000 } );
					return false;
				}
				this.matSnackBar.open( 'Änderung erfolgreich', '', { duration: 5000 } );
				return true;
			}),
			catchError(err => {
				console.log( 'An error occurred while updating a section', err );
				this.matSnackBar.open( 'Beim Aktualisieren einer Sparte ist ein Fehler aufgetreten', '', { duration: 5000 } );
				return of(false);
			})
		)
	}

}